import axios from 'axios';
import API from '../config/API';

// Settings › Business numbers: a location's phone numbers and their jobs.
const headers = () => ({ 'Content-Type': 'application/json', accessToken: localStorage.getItem('accessToken') || '' });

// The API's envelope, unwrapped; a 200 that says it failed is thrown.
function unwrap(res) {
    const body = (res && res.data) || {};
    if (body.statusCode === 0 || body.error) {
        const e = body.error || {};
        throw new Error(e.responseMessage || body.message || 'That didn’t work. Try again.');
    }
    return body.responseData !== undefined ? body.responseData : (body.data !== undefined ? body.data : body);
}
const rethrow = (e) => {
    const d = e && e.response && e.response.data;
    const msg = d && d.error && d.error.responseMessage;
    throw msg ? new Error(msg) : e;
};

export const businessNumbersService = {
    list: () => axios.get(API.BUSINESS_NUMBERS, { headers: headers() }).then(unwrap, rethrow).then((d) => (d && d.numbers) || []),
    options: (kind, areaCode) => axios.get(`${API.BUSINESS_NUMBERS}/options`, { headers: headers(), params: { kind, areaCode: areaCode || undefined } }).then(unwrap, rethrow).then((d) => (d && d.options) || []),
    buy: (body) => axios.post(API.BUSINESS_NUMBERS, body, { headers: headers() }).then(unwrap, rethrow),
    update: (id, patch) => axios.patch(`${API.BUSINESS_NUMBERS}/${encodeURIComponent(id)}`, patch, { headers: headers() }).then(unwrap, rethrow).then((d) => (d && d.numbers) || []),
    move: (id, toSalonId) => axios.post(`${API.BUSINESS_NUMBERS}/${encodeURIComponent(id)}/move`, { toSalonId }, { headers: headers() }).then(unwrap, rethrow).then((d) => (d && d.numbers) || []),
    release: (id) => axios.delete(`${API.BUSINESS_NUMBERS}/${encodeURIComponent(id)}`, { headers: headers() }).then(unwrap, rethrow).then((d) => (d && d.numbers) || []),
};

export default businessNumbersService;
